<template>
  <div class="card">
    <div class="card-body px-0 pt-0 pb-2">
      <argon-alert color="success" v-if="show_success" class="mx-2 mt-2"
        >{{ alert_msg }}
      </argon-alert>
      <div class="table-responsive p-0" v-if="measuresList">
        <table class="table align-items-center mb-0">
          <thead>
            <tr>
              <th
                class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2"
              >
                Descrizione
              </th>
              <th
                class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
              >
                Stato
              </th>
              <th
                class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
              >
                Data creazione
              </th>
              <th class="text-secondary opacity-7"></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="measure in measuresList" :key="measure._id">
              <table-row :item="measure" />
              <td class="align-middle">
                <a
                  @click="editMeasures(measure._id)"
                  class="text-secondary font-weight-bold text-xs"
                  data-toggle="tooltip"
                  data-original-title="Modifica"
                  href="javascript:;"
                >
                  <i class="fa fa-pen"></i
                ></a>
                <a
                  @click.stop="openModal(measure._id)"
                  class="text-secondary font-weight-bold text-xs ms-2"
                  data-toggle="tooltip"
                  data-original-title="Elimina"
                  href="javascript:;"
                >
                  <i class="fa fa-trash"></i
                ></a>
                <delete-modal
                  :modalId="'deleteModal' + measure._id"
                  :object="measure"
                  @deleteObject="deleteMeasure"
                  @closeModal="closeModal(measure._id)"
                />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import TableRow from "@/components/TableRow.vue";
import router from "@/router";
import DeleteModal from "@/components/deleteModal.vue";
import axios from "axios";
import ArgonAlert from "@/components/ArgonAlert.vue";

export default {
  name: "measure-table",
  props: {
    measures: {
      type: Object,
      required: false,
      default: () => ({}),
    },
    // pages: {type: Number},
    // total: {type: Number},
    // pagination_size: {type: Number},
  },
  data() {
    return {
      show_success: false,
      alert_msg: "",
      measuresList: {}
    };
  },
  components: { ArgonAlert, DeleteModal, TableRow },
  mounted() {
    this.measuresList = this.measures;
  },
  methods: {
    editMeasures(measureId) {
      router.push({ name: "misure-edit", params: { id: measureId } });
    },
    openModal(id) {
      this.$vfm.open("deleteModal" + id);
    },
    async closeModal(id) {
      await router.push("/misure-list");
      await this.$vfm.close("deleteModal" + id);
    },
    async deleteMeasure(measure) {
      this.$emit("deleteObject", measure);
      const response = await axios.delete(
        this.$endpoint + "/measure/delete/" + measure._id,
        {
          headers: {
            authorization: process.env.VUE_APP_APY_KEY,
          },
        }
      );

      if (response.data.status === "OK") {
        this.show_success = true;
        this.alert_msg = "Misura eliminata con successo";
        const index = this.measuresList.findIndex(obj => obj._id === measure._id) // find the post index
        if (~index) // if the post exists in array
          this.measuresList.splice(index, 1) //delete the post
      }

      await this.closeModal(measure._id);
    },
  },
};
</script>
